/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type VisionGalleryViewedAtUpdateMutationVariables = Types.Exact<{
  input: Types.VisionGalleryViewedAtUpdateInput;
}>;
export type VisionGalleryViewedAtUpdateMutation = {
  __typename?: "Mutation";
  visionGalleryViewedAtUpdate?: {
    __typename?: "VisionGalleryViewedAtUpdatePayload";
    result: {
      __typename?: "VisionGalleryViewedAtUpdateError";
      message: string;
    } | {
      __typename?: "VisionGalleryViewedAtUpdateSuccess";
      id: string;
    };
  } | null;
};
export const VisionGalleryViewedAtUpdateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "visionGalleryViewedAtUpdate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "VisionGalleryViewedAtUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionGalleryViewedAtUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionGalleryViewedAtUpdateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionGalleryViewedAtUpdateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type VisionGalleryViewedAtUpdateMutationFn = Apollo.MutationFunction<VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables>;

/**
 * __useVisionGalleryViewedAtUpdateMutation__
 *
 * To run a mutation, you first call `useVisionGalleryViewedAtUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisionGalleryViewedAtUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visionGalleryViewedAtUpdateMutation, { data, loading, error }] = useVisionGalleryViewedAtUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisionGalleryViewedAtUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables>(VisionGalleryViewedAtUpdateDocument, options);
}
export type VisionGalleryViewedAtUpdateMutationHookResult = ReturnType<typeof useVisionGalleryViewedAtUpdateMutation>;
export type VisionGalleryViewedAtUpdateMutationResult = Apollo.MutationResult<VisionGalleryViewedAtUpdateMutation>;
export type VisionGalleryViewedAtUpdateMutationOptions = Apollo.BaseMutationOptions<VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables>;